<template>
  <div class="contenedor" >
    <!-- {{store.state.minReal}} -->
    
    <div class="textoTrancu"><b>Tiempo transcurrido</b></div>
    <div id='watch'>
      <p class="p">
        00:00:00
      </p>
    </div>
    </div>
    <!-- <input  type="button" @click="start" value="Start" />
      <input type="button"  @click="pause" value="Pause" />
      <input type="button"  @click="resumeTimer" value="Resume" /> -->
</template>
  <script>
import { useStore } from 'vuex'
export default {

  data() {
    return {
      sec: -1,
      min: 0,
      hr: 0,
      resta: null,
      parametro: 0,
      notificaciones: 0,
      divide: 0,
    }
  },
  setup() {
    const store = useStore();
    return {store}
  },

  mounted() {
    this.start();
  },
  methods: {

    twoDigits(digit) {
      if (digit < 10) {
        return ('0' + digit)
      } else {
        return (digit)
      }
    },

    start() {
      // this.sec = -1
      // this.min = 0
      // this.hr = 0
      this.watch()
      this.interval = setInterval(this.watch, 1000)
    },
      watch() {
        
      this.sec++
       if(this.store.state.btnFinalizar == 3){
        this.pause();
      }

      if (this.sec == 60 ) {
        this.min++
        this.sec = 0

        if (this.min == 60) {
          this.min = 0
          this.hr++
        } 

        if (this.hr == 1 && this.min == 10 && this.sec == 0) {
           this.pause()
          //  this.$router.push('/Fin-Examen')
          this.$store.commit('setBtnFinalizar', 2)
          this.$store.commit('setInicioExmen', 2)

        }
      }
       document.getElementById('watch').innerText = this.twoDigits(this.hr) + ':' + this.twoDigits(this.min) + ':' + this.twoDigits(this.sec)
  },

    pause() {
      clearInterval(this.interval)
    },
  },
}

</script>
  <style lang="scss">
// @import '@/fonts/fonts.scss';
    
  .contenedor {
    background: #00B5E2;
    display: flex;
    color: #ffff;
    text-decoration: bold;
    justify-content: center;
    width: 254px;
    height: 40px;
    margin: auto;
    padding: 3px;
    border-radius: 8px;
  }
  
  .textoTrancu {
    margin: auto;
  }

  b{
    font-size: 15px;
  }
  
  #watch {
    background: #ffff;
    width: 86px;
    margin: auto;
    height: auto;
    text-align: center;
    color: #00B5E2;
    border-radius: 8px;
  }
  </style>

